import React, { useState } from 'react';
import { any, node, number, string } from 'prop-types';
import classNames from 'classnames';

import { AspectRatioWrapper, VideoPlayer, Promised } from '../../components';

import css from './VideoFromFile.module.css';

const createVideoPreview = file => file && URL.createObjectURL(file);

// readVideo returns a promise which is resolved
// when FileReader has loaded given file as dataURL
const readVideo = file =>
  new Promise((resolve, reject) => {
    if (!window?.FileReader) {
      reject(new Error(`No FileReader found from window scope.`));
      return;
    }
    const reader = new FileReader();
    reader.onload = e => resolve(e.target.result);
    reader.onerror = e => {
      // eslint-disable-next-line
      console.error('Error (', e, `) happened while reading ${file.name}: ${e.target.result}`);
      reject(new Error(`Error reading ${file.name}: ${e.target.result}`));
    };
    reader.readAsDataURL(file);
  });

// Create elements out of given thumbnail file
const VideoFromFile = props => {
  const [promisedVideo, setPromisedVideo] = useState(readVideo(props.file));
  const { className, rootClassName, aspectWidth, aspectHeight, file, id, children } = props;
  const classes = classNames(rootClassName || css.root, className);

  // Video preview which helps reading the file even before
  // we receive dataURL from the FileReader promise
  const srcPreview = createVideoPreview(file);

  return (
    <Promised
      key={id}
      promise={promisedVideo}
      renderFulfilled={dataURL => {
        const videoSrc = dataURL || srcPreview;
        return (
          <div className={classes}>
            <AspectRatioWrapper width={aspectWidth} height={aspectHeight}>
              <VideoPlayer
                video={{ id, src: videoSrc }}
                settings={{ playerTime: false, hoverPlay: false }}
              />
            </AspectRatioWrapper>
            {children}
          </div>
        );
      }}
      renderRejected={() => (
        <div className={classes}>
          <AspectRatioWrapper width={aspectWidth} height={aspectHeight}>
            <VideoPlayer
              video={{ id, src: null }}
              settings={{ playerTime: false, hoverPlay: false }}
            />
          </AspectRatioWrapper>
          {children}
        </div>
      )}
    />
  );
};

VideoFromFile.defaultProps = {
  className: null,
  children: null,
  rootClassName: null,
  aspectWidth: 1,
  aspectHeight: 1,
};

VideoFromFile.propTypes = {
  className: string,
  rootClassName: string,
  aspectWidth: number,
  aspectHeight: number,
  file: any.isRequired,
  id: string.isRequired,
  children: node,
};

export default VideoFromFile;
